<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12 text-center">
					<span *ngIf="dbRegion == 'us-nyc' || dbRegion == 'us-sfo-1'">Hand made in Oregon, 🇺🇸 USA,</span>
					<span *ngIf="dbRegion == 'ca-tor'">Minutieusement fabriqué au Québec, 🇨🇦 Canada,</span>
					<span *ngIf="dbRegion == 'au-syd'">Hand-carved downunder in 🇦🇺 Australia,</span>
					<span *ngIf="dbRegion == 'eu-fra'">Hecho a mano en 🇪🇸 España,</span>
					{{year}} &copy; Troly, and Open Software
					<br/>Designed by <strong>Local Businesses</strong>, who value relationships & sales, <a href=>help us and others</a>, anytime you have a minute
					<code *ngIf="debug()"><br>app: {{ appConfig.getString('TROLY_APP_VERSION') }}, api: {{ appConfig.getString('TROLY_API_VERSION') }}, endpoint: {{ appConfig.getString('TROLY_API_URL') }}</code>
            </div>
        </div>
    </div>
</footer>
